function createSVGObjectPlus() {
  let svgNS = 'http://www.w3.org/2000/svg';
  let newSVG = document.createElementNS(svgNS, 'svg');
  newSVG.setAttribute('width', '16');
  newSVG.setAttribute('height', '16');
  newSVG.setAttribute('viewBox', '0 0 16 16');
  newSVG.setAttribute('fill', 'none');
  newSVG.setAttribute('class', 'random-plus random-point');

  let path = document.createElementNS(svgNS, 'path');
  path.setAttribute('fill-rule', 'evenodd');
  path.setAttribute('clip-rule', 'evenodd');
  path.setAttribute('d', 'M8.5 0H7.5V7.5H0V8.5H7.5V16H8.5V8.5H16V7.5H8.5V0Z');
  path.setAttribute('fill', '#333333');

  newSVG.appendChild(path);

  document.body.appendChild(newSVG);

  let docWidth = document.documentElement.scrollWidth;
  let docHeight = document.documentElement.scrollHeight;

  newSVG.style.top = Math.floor(Math.random() * docHeight) + 'px';
  newSVG.style.right = Math.max(Math.floor(Math.random() * docWidth), 0) + 'px';

  let animationDuration = Math.random() * 10 + 20; // between 20 and 30 seconds
  let animationDelay = Math.random() * 5;

  newSVG.style.animationDuration = animationDuration + 's';
  newSVG.style.animationDelay = animationDelay + 's';

  newSVG.classList.add('random-move');
}

for (let i = 0; i < 30; i++) {
  createSVGObjectPlus();
}
